import { FunctionComponent } from "react"
import { useTypedDispatch } from "../../../app/store"
import { setAddConnectionOpenFlag } from "../decisionsSlice"
import BaseButton from "../../../components/Button/base-button"

type DecisionPlanButtonsProps = {
  handleDecisionsClick: () => void
  disabledCheck: (action: string) => boolean
  hideConnections?: boolean
}

const DecisionPlanButtons: FunctionComponent<DecisionPlanButtonsProps> = ({
  handleDecisionsClick,
  disabledCheck,
  hideConnections = false,
}) => {
  const dispatch = useTypedDispatch()

  const handleAddConnectionsClick = () => {
    dispatch(setAddConnectionOpenFlag(true))
  }

  return (
    <div className="w-full relative flex flex-col items-start justify-start text-left text-base text-gray-700 font-text-md-semibold">
      {/* BUG FIX: Changed layout to prevent button text wrapping */}
      {/* Using fixed heights and proper flex constraints */}
      <div
        id="decisionPlanButtons"
        className="self-stretch flex flex-row items-stretch justify-start gap-3">
        {/* Connections button hidden for team simulations */}
        {!hideConnections && (
          <BaseButton
            id="addConnectionsButton"
            onClick={handleAddConnectionsClick}
            disabled={disabledCheck("add")}
            variant="secondary"
            className="flex-1 flex flex-row items-center justify-center gap-2 whitespace-nowrap overflow-hidden h-11">
            <img
              className="w-4 h-4 shrink-0"
              alt="Add Connections"
              src="/v3/assets/plus.svg"
            />
            <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">
              Connections
            </span>
            <img
              className="w-4 h-4 shrink-0 cursor-help"
              alt="Help"
              src="/v3/assets/help-circle.svg"
              title="After you make a decision or plan, you can share your thinking by selecting any messages or previous actions that led you to make that choice. Click here to add connections to a decision or plan before you execute it."
            />
          </BaseButton>
        )}

        <BaseButton
          id="submitDecisionButton"
          onClick={handleDecisionsClick}
          disabled={disabledCheck("submit")}
          variant="primary"
          className={hideConnections ? "w-full h-11" : "flex-1 h-11"}>
          Submit
        </BaseButton>
      </div>
    </div>
  )
}

export default DecisionPlanButtons
